import { defineStore } from 'pinia';

// TODO: GUGG Typescript
// interface State {
//   clicked: Boolean;
//   filter: String;
//   payload: Object;
// }

export const useEventStore = defineStore('eventStore', {
  state: () => ({
    clicked: false,
    payload: {}
  }),
  actions: {
    updateEventState(value) {
      Object.keys(value).map(val => {
        if (val in this) {
          this[val] = value[val];
        }
      });
    }
  }
});
